import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  list: {
    '&.tiny': {
      padding: 0,
    },
  },
  listItem: {
    alignItems: 'end',
    '&.tiny': {
      padding: 0,
    },
  },
  avatar: {
    margin: theme.spacing(1, 0, 0, 0),
    backgroundColor: theme.palette.primary.main,
  },
  textField: {
  },
  marginBottom: {
    marginBottom: theme.spacing(1),
  },
  eraseComment: {
    marginTop: theme.spacing(1),
    display: 'block',
  }
}));
